// extracted by mini-css-extract-plugin
export default {"wrapper":"_e095d53d","small":"_faf3d3b1","medium":"_e3676fd3","spinner":"_2ab2c8b3"};